// extracted by mini-css-extract-plugin
module.exports = {"container":"idt-windowbutton_container__38i3g","chevron":"idt-windowbutton_chevron__1nyfu"};